import api from "../config/api";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function useAuth() {
  const navigate = useNavigate();
  const forgetPassword = async (username) => {
    const isAuth = await api.post("auth/forgotPassword", username);
    return isAuth;
  };

  const changePassword = async (data) => {
    const res = await api.post("auth/changePassword", data);
    if (res.ok) {
      navigate("/login");
    }
    return res;
  };

  const signIn = async (user) => {
    const isAuth = await api.post("auth", user);
    if (isAuth.ok) {
      localStorage.setItem("token", isAuth.data);
      navigate("/", { replace: true });
      window.location.reload();
      return jwtDecode(isAuth.data);
    } else {
      if (isAuth.status === 400) {
        toast.error(isAuth.data);
        return isAuth.data;
      }
      toast.error(isAuth.originalError.message);
      return false;
    }
  };

  const signOut = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
    window.location.reload();
  };

  const getCurrentUser = () => {
    const token = localStorage.getItem("token");

    if (token) {
      const user = jwtDecode(token);
      api.setHeader("x-auth-token", token);
      return user;
    }
    return null;
  };

  return { signIn, signOut, getCurrentUser, forgetPassword, changePassword };
}
